<template>
  <div
    class="rounded-lg bg-white border border-gray-300 shadow-md sm:p-6 p-2 transition-all h-fit duration-300 hover:shadow-lg cursor-pointer"
    :class="{ 'overflow-hidden': loaderCard }"
  >
    <div v-if="loaderCard" class="w-full animate-pulse">
      <div class="relative overflow-hidden">
        <div
          class="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-lg w-48 mb-6 shimmer"
        ></div>
      </div>

      <div class="space-y-4">
        <div class="relative overflow-hidden">
          <div
            class="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-md max-w-[85%] shimmer"
          ></div>
        </div>
        <div class="relative overflow-hidden">
          <div
            class="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-md w-full shimmer"
          ></div>
        </div>
        <div class="relative overflow-hidden">
          <div
            class="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-md max-w-[75%] shimmer"
          ></div>
        </div>
        <div class="relative overflow-hidden">
          <div
            class="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-md max-w-[90%] shimmer"
          ></div>
        </div>
        <div class="relative overflow-hidden">
          <div
            class="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-md max-w-[65%] shimmer"
          ></div>
        </div>
      </div>
    </div>

    <transition
      name="fade"
      mode="out-in"
      enter-active-class="transition-all duration-300 ease-out"
      enter-from-class="opacity-0 transform translate-y-2"
      enter-to-class="opacity-100 transform translate-y-0"
    >
      <div v-if="!loaderCard" key="content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  loaderCard?: boolean
}>()
</script>

<style scoped>
.shimmer {
  position: relative;
  overflow: hidden;
}

.shimmer::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 2s infinite;
}

.efore {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
